
function setTapBox() {
  var get_tabbox = localStorage.getItem("beautyBox_TapBox");
  if (get_tabbox == "Clicked") {
    $(".tap-click-view").hide();
    $(".tap-hover-view").show();
    $('body').addClass('show-annoucement');
    
  } else {
    $(".tap-click-view").show();
    $(".tap-hover-view").hide();
    $('body').removeClass('show-annoucement');
  }
}

$(document).ready(function () {
  setTapBox();
  //$('.pro-beauty-box .info-bar').attr('style','display: block !important');
  $(".tap-click-view").click(function () {
    localStorage.setItem("beautyBox_TapBox", "Clicked");
    setTapBox();
  });
});



$(document).ready(function(){    
  function updateTimer() {
    var now = new Date(); // Get current date and time
    var targetTime = new Date(now); // Create a new date object
    var currentDate = new Date();
    if (currentDate.getHours() < 11) {
      // If before 6 PM, use today's date
      var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      var formattedDate = currentDate.toLocaleDateString('en-US', options);
      $(".delivery-text .day-time").text(formattedDate);
    } else {
      // If after 6 PM, use tomorrow's date
      currentDate.setDate(currentDate.getDate() + 1);
      var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      var formattedDate = currentDate.toLocaleDateString('en-US', options);
      $(".delivery-text .day-time").text(formattedDate);
    }
  }
  setInterval(updateTimer, 1000);
});
function getTheCookie(name) {
  const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
if (getTheCookie('timer_min') > new Date().getTime()) {
  var time = getTheCookie('timer_min');
  var timer_min = setInterval(function () {
    var left = time - new Date().getTime();
    var min = Math.floor(left / 60000);
    // console.log(min);
    if (min < 10) {
      min = "0" + min;
    }
    var sec = Math.floor(left % 60000 / 1000);
    if (sec < 10) {
      sec = "0" + sec;
    }
    document.querySelector('#timer_min').innerHTML = min + ':' + sec;
    if (left < 1000) {
      clearInterval(timer_min);
      document.cookie = 'timer_min=""; path=/; domain=glamrdip.com; secure=true; expires=-1';
    }
  }, 1000);
} else {
  document.cookie = 'timer_min=' + (new Date().getTime() + 900000) + '; path=/; domain=glamrdip.com; secure=true; expires=' + new Date(new Date().getTime() + 3600000 * 24).toUTCString();
  var time = new Date().getTime() + 900000;
  var timer_min = setInterval(function () {
    var left = time - new Date().getTime();
    var min = Math.floor(left / 60000);
    // console.log(min);
    if (min < 10) {
      min = "0" + min;
    }
    var sec = Math.floor(left % 60000 / 1000);
    if (sec < 10) {
      sec = "0" + sec;
    }
    document.querySelector('#timer_min').innerHTML = min + ':' + sec;
    if (left < 1000) {
      clearInterval(timer_min);
      document.cookie = 'timer_min=""; path=/; domain=glamrdip.com; secure=true; expires=-1';
    }
  }, 1000);
}

function r(t, r) {
  return Math.floor(Math.random() * (r - t + 1) + t);
}
var variation = 5, c = r(75, 250);
$("#counter").text(c);
$("#counter1").text(c);
setInterval(function () {
  var t = r(-variation, variation);
  (c += t), $("#counter").text(c);
  (c += t), $("#counter1").text(c);
}, 3000);

var variation = 5, c = r(75, 140);
$(".product_counter_1").text(c);
$(".product_counter_2").text(c);
setInterval(function () {
  var t = r(-variation, variation);
  (c += t), $(".product_counter_1").text(c);
  (c += t), $(".product_counter_2").text(c);
}, 6000);

$(document).on("click", ".custom-aattcc2", function () {
  $(this).val("Adding to cart...");
  setTimeout(function () { $(".custom-aattcc2").val("Add to Cart"); }, 8000);
  $(".custom-aattcc").trigger("click");
});

/* Qty plus/mius */
jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 1) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(1);
        }
    });
});